export const REPLY_RECOMMENDATIONS_MESSAGE = 'REPLY_RECOMMENDATIONS_MESSAGE';
export const REPLY_RECOMMENDATIONS_WITH_REASON_MESSAGE = 'REPLY_RECOMMENDATIONS_WITH_REASON_MESSAGE';